<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
   -webkit-overflow-scrolling: touch;
  /* text-align: center;
  color: #2c3e50; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue